import Vue from 'vue';
import Notifications from 'vue-notification';

Vue.use(Notifications, {
  componentName: 'VueNotifications',
});

const defaults = {
  ignoreDuplicates: true,
  duration: 5000,
};

const toast = {
  success: (payload) => {
    Vue.notify({
      ...defaults,
      type: 'success',
      ...payload,
    });
  },
  danger: (payload) => {
    Vue.notify({
      ...defaults,
      type: 'danger',
      ...payload,
    });
  },
  warning: (payload) => {
    Vue.notify({
      ...defaults,
      type: 'warning',
      ...payload,
    });
  },
};

Vue.prototype.$toast = toast;

export default toast;
